module.exports = __webpack_public_path__ + "img/icon-invisible-red.d3f52003.svg";